<nav class="roles" [ngClass]="{ 'mobile-menu': isMobileMenu }">
  <a
    *ngIf="'Studia.PlatformaStudenta.Osoby.DaneOsobowe' | hasPermission"
    class="roles__role"
    routerLinkActive="active"
    [routerLink]="baseModulesRoutes.mojeDane"
    i18n
  >
    Moje dane
  </a>
  <a
    *ngIf="'KonfiguracjaUczelni' | hasPermission"
    class="roles__role"
    routerLinkActive="active"
    [routerLink]="baseModulesRoutes.administration"
    i18n
    >Administracja</a
  >
  <a
    *ngIf="'Studia' | hasPermission"
    class="roles__role"
    routerLinkActive="active"
    [routerLink]="baseModulesRoutes.studies"
    i18n
    >Studia</a
  >
  <a
    *ngIf="'Dyplomowanie' | hasPermission"
    class="roles__role"
    routerLinkActive="active"
    [routerLink]="baseModulesRoutes.dissertation"
    i18n
    >Dyplomowanie</a
  >
  <a
    *ngIf="'Praktyki' | hasPermission"
    class="roles__role"
    routerLinkActive="active"
    [routerLink]="[baseModulesRoutes.practices]"
    i18n
    >Praktyki</a
  >
  <a
    *ngIf="'Wnioski' | hasPermission"
    class="roles__role"
    routerLinkActive="active"
    [routerLink]="[baseModulesRoutes.requests]"
    i18n
    >Wnioski</a
  >
  <a
    *ngIf="'Stypendia' | hasPermission"
    class="roles__role"
    routerLinkActive="active"
    [routerLink]="[baseModulesRoutes.scholarships]"
    i18n
    >Stypendia</a
  >
  <a
    *ngIf="'Finanse' | hasPermission"
    class="roles__role"
    routerLinkActive="active"
    [routerLink]="baseModulesRoutes.finances"
    i18n
    >Finanse</a
  >
  <a
    *ngIf="'BiuroKarier' | hasPermission"
    [href]="baseModulesRoutes.careerOffice"
    target="_blank"
    class="roles__role"
    i18n
    >Biuro karier</a
  >
  <a *ngIf="'Akademiki' | hasPermission" [href]="baseModulesRoutes.dormitories" target="_blank" class="roles__role" i18n
    >Akademiki</a
  >
  <a
    *ngIf="'Rekrutacja' | hasPermission"
    [href]="baseModulesRoutes.recruitment"
    target="_blank"
    class="roles__role"
    i18n
    >Rekrutacja</a
  >
  <a
    *ngIf="'Ankiety' | hasPermission"
    [href]="baseModulesRoutes.questionnaires"
    target="_blank"
    class="roles__role"
    i18n
    >Ankiety</a
  >
  <a
    *ngIf="'RepozytoriumPlikow' | hasPermission"
    class="roles__role"
    routerLinkActive="active"
    [routerLink]="baseModulesRoutes.filesRepository"
    i18n
  >
    Repozytorium plików
  </a>
</nav>
